import PropTypes                 from 'prop-types';
import React, {useEffect} from 'react';
import {  useTranslation } from 'react-i18next';
import TableContainer            from '@material-ui/core/TableContainer';
import Table                     from '@material-ui/core/Table';
import TableHead                 from '@material-ui/core/TableHead';
import TableCell                 from '@material-ui/core/TableCell';
import TableRow                  from '@material-ui/core/TableRow';
import TableBody                 from '@material-ui/core/TableBody';

import { Grid }                  from '@material-ui/core';
import {useShellPort} from '../../../hooks/useShells';
import CircularProgress from '@material-ui/core/CircularProgress';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '../../core/input/Button';
import DeleteShellPortDialog from './DeletePortDialog';
import Toolbar from '../../core/typography/Toolbar';
import AddIcon from '@material-ui/icons/Add';
import CreateShellPortDialog from './CreatePortDialog';
import EditIcon from '@material-ui/icons/Edit';


const ShellPortTable = ({ shell }) => {
	const { t } = useTranslation();
	const [ports, fetch, loading] = useShellPort(shell.Shell__);
	const [showDelete, setShowDelete] = React.useState(null);
	const [showCreate, setShowCreate] = React.useState(null);
	const [selectedPort, setSelectedPort] = React.useState(null);

	useEffect(() => {fetch();}, []);

	return (
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<Toolbar
					disableGutters
					title={t('shell_port')}
				>
					<Button
						onClick={() => setShowCreate(true)}
						size="small"
						variant="contained"
						color="primary"
						startIcon={<AddIcon/>}
					>
						{t('create_btn')}
					</Button>
				</Toolbar>
			</Grid>
			<Grid item xs={12}>
				<TableContainer>
					<Table>
						<TableHead>
							<TableRow>
								<TableCell> {t('tablecell_shell_port_name')}</TableCell>
								<TableCell>{t('tablecell_shell_port_protocol')}</TableCell>
								<TableCell>{t('tablecell_shell_port_guest_port')}</TableCell>
								<TableCell>{t('tablecell_shell_port_external_endpoint')}</TableCell>
								<TableCell>{t('tablecell_shell_port_source')}</TableCell>
								<TableCell align='right'>{t('tablecell_actions')}</TableCell>
							</TableRow>
						</TableHead>
						<TableBody>
							{(loading || !ports) && <TableRow><TableCell colSpan={5} align={'center'}><CircularProgress/></TableCell></TableRow>}
							{!loading && (ports && ports.data.length < 1) && <TableRow><TableCell colSpan={5} align={'center'}>{t('table_empty_text')}</TableCell></TableRow>}
							{!loading && ports && ports.data.map(port => (
								<TableRow key={port.Shell_Port__}>
									<TableCell>{port.Name}</TableCell>
									<TableCell>{port.Protocol}</TableCell>
									<TableCell>{port.Guest_Port}</TableCell>
									<TableCell>{port.Extern_Ip+':'+port.Extern_Port}</TableCell>
									<TableCell>{port.Source ?? t('any')}</TableCell>
									<TableCell align='right'>
										<Grid container spacing={3} justify='flex-end'>
											<Grid item xs={6}>
												<Button
													color='primary'
													onClick={() => {
														setSelectedPort(port);
														setShowCreate(true);
													}}
													variant='contained'
													disabled={loading}
													loading={loading}
													startIcon={<EditIcon/>}
												>
													{t('edit_btn')}
												</Button>
											</Grid>
											<Grid item xs={6}>
												<Button
													color='secondary'
													onClick={() => {
														setShowDelete(port);
													}}
													variant='outlined'
													disabled={loading}
													loading={loading}
													startIcon={<DeleteIcon/>}
												>
													{t('delete_port')}
												</Button>
											</Grid>
										</Grid>

									</TableCell>
								</TableRow>
							))}
						</TableBody>
					</Table>
				</TableContainer>
			</Grid>
			{!!showDelete && <DeleteShellPortDialog open={!!showDelete} setOpen={setShowDelete} port={showDelete} refreshing={loading} refreshList={fetch} /> }
			<CreateShellPortDialog
				key={selectedPort?.Shell_Port__ ?? 'create'}
				open={showCreate}
				setOpen={
					(v) => {
						setSelectedPort(null);
						setShowCreate(v);
					}
				}
				refreshList={fetch}
				refreshing={loading}
				shell={shell}
				portToUpdate={selectedPort}
			/>
		</Grid>
	);
};

export default ShellPortTable;

ShellPortTable.propTypes = {
	setShell: PropTypes.func.isRequired,
	shell: PropTypes.object.isRequired
};
